(function() {
  window.adConfigs = window.adConfigs || {};

  const flavours = ['Caramel', 'Peanut Butter', 'Pistachio', 'Raspberry', 'Hazelnut', 'Malt-Cornflakes'];

  function buildFlavourList(leadFlavour) {
    const reordered = [leadFlavour, ...flavours.filter(f => f !== leadFlavour)];
    return 'Six bars: ' + reordered.join(' · ');
  }

  function buildFlavourChips(leadFlavour) {
    const reordered = [leadFlavour, ...flavours.filter(f => f !== leadFlavour)];
    const chips = reordered.map((f, i) =>
      `<span class="bb-flavour-chip">${f}</span>${i < reordered.length - 1 ? ' <span class="bb-sep">·</span> ' : ''}`
    ).join('');
    return `<span style="color: #5b4637;">Six handmade filled chocolate bars</span><br>${chips}`;
  }

  const cravingImages = {
    'caramel':       'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving-Caramel-PDP.jpg?v=1775654171',
    'peanutbutter':  'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving-Peanut-Butter-PDP.png?v=1775663357',
    'peanutbutter2': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving_ad_outside_caramel_stretch.png?v=1775820938',
    'pistachio':     null,
    'raspberry':     null,
    'pretzel':       null,
    'smaltz':        null,
  };

  const cravingFlavours = {
    'caramel':       'Caramel',
    'peanutbutter':  'Peanut Butter',
    'peanutbutter2': 'Peanut Butter',
    'pistachio':     'Pistachio',
    'raspberry':     'Raspberry',
    'pretzel':       'Hazelnut',
    'smaltz':        'Malt-Cornflakes',
  };

  Object.entries(cravingFlavours).forEach(([key, displayName]) => {
    window.adConfigs[`craving-${key}`] = {
      subline1: "Here we are.",
      subline2: buildFlavourChips(displayName),
      cartSub:  buildFlavourList(displayName),
      image:    cravingImages[key],
    };
  });
})();